export default __webpack_public_path__ + "static/media/hero.ca19034d.png";